import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../lib/theme'

export default function ThemeToggle({ showLabel = false }: { showLabel?: boolean }) {
  const [theme, setTheme] = useTheme()
  const nextTheme = theme === 'light' ? 'dark' : 'light'
  const label = `Switch to ${nextTheme} mode`

  return (
    <button
      type="button"
      className={`theme-toggle${showLabel ? ' theme-toggle-labeled' : ''}`}
      onClick={() => setTheme(nextTheme)}
      aria-label={label}
      title={label}
    >
      {theme === 'light' ? <Moon size={13} /> : <Sun size={13} />}
      {showLabel && <span>{theme === 'light' ? 'Dark mode' : 'Light mode'}</span>}
    </button>
  )
}
